//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Issue.js";
import "../no/Object.js";
import "../no/BasePart.js";
import "../no/Session.js";
let d=[[[0,"CurrentMode",1,1],[0,"CurrentSite",0,"Issue.IssueSite",0]],[[["list"],"CreateIssueContent",{R_:{issue:"Issue.IssueContent"}},1,0],[["fileSpec","name","type"],"CreateIssueAttachment",{R_:{attachment:"Issue.IssueAttachment"}},3,0],[["issue"],"CreateIssueContentBuilder",{R_:{builder:"Issue.IssueContentBuilder"}},1,0],[["siteUrl","userName","password"],"Connect",{R_:{site:"Issue.IssueSite"}},3,1],[[],"Disconnect",{},0,1],[[],"GetWorkingList",{R_:{list:"Issue.IssueList"}},0,0],[["list"],"SetWorkingList",{},1,0],[["issue"],"GetIssueState",{R_:{state:''}},1,0],[["attachment"],"GetAttachmentState",{R_:{state:''}},1,0],[["property"],"GetPropertyState",{R_:{state:''}},1,0],[["subsetPart"],"CreateIssueSnapshotSubsetBuilder",{R_:{builder:"Issue.SnapshotSubsetBuilder"}},1,0],[["issue"],"CreateIssueSnapshotWorksetBuilder",{R_:{builder:"Issue.SnapshotWorksetBuilder"}},1,0],[["bookmarkFileSpec","imageFileSpec","name"],"CreateAttachmentForSnapshot",{R_:{attachment:"Issue.IssueAttachment"}},3,0],[[],"CreateAttachmentForScreenImage",{R_:{attachObj:"Issue.IssueAttachment"}},0,0],[[],"CreateAttachmentForBookMark",{R_:{attachObj:"Issue.IssueAttachment"}},0,0],[[],"CaptureAndCreateAttachmentForSnapshot",{R_:{attachObj:"Issue.IssueAttachment"}},0,0],[["briefcaseName","filePath"],"CreateBriefcase",{R_:{briefcase:"Issue.IssueBriefcase"}},2,0],[["filePath"],"OpenBriefcase",{R_:{list:"Issue.IssueBriefcase"}},1,0]],[["IssueListCollection","Issue.IssueListCollection",0]]];
SPLM.Issue.IssueManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Issue.IssueManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Issue.IssueManager.Mode = Object.freeze({
    "TeamcenterCommunity" : "TeamcenterCommunity", "Teamcenter" : "Teamcenter", "Briefcase" : "Briefcase"});

SPLM.Issue.IssueManager.State = Object.freeze({
    "Original" : "Original", "Created" : "Created", "Modified" : "Modified", "Removed" : "Removed"});

export default SPLM;